var exports = {
  "Dk": "Composer__xdScmc",
  "jY": "isDraggedOver__nrNrDr",
  "rK": "QuotaNotice__dTdA-l",
  "hI": "ComposerEmbedded__miEeQW",
  "ge": "ComposerInline___18hkp",
  "pp": "EmptyState__DN6IKU",
  "rh": "ComposerLayout__Qo1Wgk",
  "oD": "HomeEmptyState__LiB0ia",
  "Ip": "HomeEmptyStateInner__vCFwYD",
  "wz": "HomeEmptyStateHero__pvekbv",
  "qX": "EmptyStateIcon__WyIhdw",
  "SI": "EmptyStateSuggestions__R1AYLQ",
  "K3": "SuggestionPill__v6crhb",
  "a6": "EmptyStateDisclaimer__ECFb3t",
};

module.exports = exports;
